import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Login from "./Login";
import ListBooking from "./ListBooking";
import AddBooking from "./AddBooking";
import Operating from "./Operating";
import CalendarMess from "./CalendarMess";
import Itinerary from "./Itinerary";
import Accommodation from "./Accommondation";
import Vendor from "./Vendor";
import MessTool from "./messtool";
import AIChat from "./AIChat";
import User from "./User";
import { AdminRoute, OperOrAdminRoute } from "./components/ProtectedRoute";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<App />}>
        <Route index element={<Navigate to="/booking" replace />} />
        <Route path="booking" element={<ListBooking />} />
        <Route path="sample-booking" element={<AddBooking />} />
        <Route path="itinerary" element={<Itinerary />} />
        <Route path="location" element={<Accommodation />} />
        <Route path="user" element={<User />} />
        <Route
          path="vendor"
          element={
            <AdminRoute>
              <Vendor />
            </AdminRoute>
          }
        />
        <Route
          path="operating"
          element={
            <OperOrAdminRoute>
              <Operating />
            </OperOrAdminRoute>
          }
        />
        <Route
          path="calendar-mess"
          element={
            <OperOrAdminRoute>
              <CalendarMess />
            </OperOrAdminRoute>
          }
        />
        <Route
          path="messtool"
          element={
            <AdminRoute>
              <MessTool />
            </AdminRoute>
          }
        />
        <Route
          path="ai-chat"
          element={
            <OperOrAdminRoute>
              <AIChat />
            </OperOrAdminRoute>
          }
        />
        <Route path="*" element={<Navigate to="/booking" replace />} />
      </Route>
    </Routes>
  );
}
